import React, { Component } from "react";

// import UI components
import { Row, Col, Button, FormGroup } from "reactstrap";
import { Formik, Form } from "formik";
import CustomisedModal from "components/Application/CustomisedModal";

// import form validator
import SimpleReactValidator from "simple-react-validator";

// import custom validator
import {
  lessThanFileSizeValidator,
  fileTypeValidator,
} from "helpers/customValidator";

// import constants
import { SUBMIT } from "constants/commonConstants";
import { IMAGE_FILE_TYPE } from "helpers/constants";
import { SUCCESS, DANGER } from "constants/commonConstants";

import { toastrMessage } from "helpers/messageHelper";
import { fileCompress, filePreview } from "helpers/generalUtils";

import {
  updateProductImagesByProductDetailIdRequest,
  getProductImagesByProductDetailIdRequest,
} from "store/actions";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";

import { makeProductDetailSelectField } from "store/ProductDetail/selector";

import { jsonToFormData } from "helpers/axiosRequestData";
import { createStructuredSelector } from "reselect";

class ImageUpdateForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      productImageData: productImageDataInitialState(),
      imagePreview: [],
    };

    this.validator = new SimpleReactValidator({
      validators: Object.assign(
        lessThanFileSizeValidator(),
        fileTypeValidator()
      ),
    });
  }

  UNSAFE_componentWillReceiveProps(nextprops) {
    if (
      nextprops.productDetailApiResponse &&
      this.props.productDetailApiResponse !== nextprops.productDetailApiResponse
    ) {
      if (nextprops.productDetailApiResponse.isSuccessResponse) {
        toastrMessage(
          nextprops.productDetailApiResponse.responseMessage,
          SUCCESS
        );
        this.props.getProductImagesByProductDetailIdRequest(
          this.props.productDetailId
        );
        this.resetForm(true);
      } else if (!nextprops.productDetailApiResponse.isSuccessResponse) {
        toastrMessage(
          nextprops.productDetailApiResponse.responseMessage,
          DANGER
        );
      }
    }
  }

  resetForm = (closeModal) => {
    this.setState({
      productImageData: productImageDataInitialState(),
      imagePreview: [],
    });
    this.validator.hideMessages();

    if (closeModal) {
      this.props.closeModal();
    }
  };

  handleFilePreview = async (event, setFieldValue) => {
    // check if any one file is selected by user
    if (event.target.files.length > 0) {
      let files = [];
      // convert to array
      for (let i = 0; i < event.target.files.length; i++)
        files.push(event.target.files[i]);

      // set value to the formik
      await setFieldValue("productImages", files);

      if (this.validator.fieldValid("productImages")) {
        // load the images for the preview
        let preview = [];
        for (let i = files.length - 1; i >= 0; i--) {
          try {
            let response = await fileCompress(files[i]);
            files[i] = response;
            response = await filePreview(response);

            preview.push(response);
          } catch (error) {
            files.splice(i, 1);
          }
        }
        this.setState({
          imagePreview: preview,
        });

        setFieldValue("productImages", files);
      } else {
        this.setState({ imagePreview: [] });
      }
    }
  };

  formSubmit = (values) => {
    if (this.validator.allValid()) {
      this.setState({ productImageData: values });
      // values.productImages.forEach(image => {
      //   data.append("productImages", image)
      // })
      const jsonProductImages = {
        productImages: values.productImages,
      };
      const data = jsonToFormData(jsonProductImages);
      this.props.updateProductImagesByProductDetailIdRequest(
        this.props.productDetailId,
        data
      );
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  render() {
    return (
      <React.Fragment>
        <CustomisedModal
          modalClass="modal-lg"
          isModalOpen={this.props.formDialog}
          modalTitle="Upload Images"
          onModalDismiss={() => this.resetForm(true)}
        >
          <Formik
            initialValues={this.state.productImageData}
            enableReinitialize={true}
            onSubmit={this.formSubmit}
          >
            {({ values, setFieldValue }) => (
              <Form>
                <Row>
                  <Col lg="12">
                    <Row className="form-group">
                      <Col sm="4" lg="3">
                        <label>Product Images</label>
                      </Col>
                      <Col sm="8" lg="5">
                        <div className="custom-file">
                          <input
                            type="file"
                            className="custom-file-input"
                            name="productImages"
                            accept="image/*"
                            onClick={(e) => (e.target.value = null)}
                            id="customFile"
                            onChange={(event) =>
                              this.handleFilePreview(event, setFieldValue)
                            }
                            multiple
                          />
                          <label
                            className="custom-file-label"
                            htmlFor="customFile"
                          >
                            {values.productImages.length > 0
                              ? values.productImages.length + " files"
                              : "Choose file"}
                          </label>
                        </div>
                        {this.validator.message(
                          "productImages",
                          values.productImages,
                          `required|lessThanFileSize:5242880|fileType:${IMAGE_FILE_TYPE}`
                        )}
                      </Col>
                    </Row>

                    {this.state.imagePreview.length > 0 && (
                      <Row>
                        {this.state.imagePreview.map((preview, index) => (
                          <Col xl="3" md="6" key={index}>
                            <img
                              className="img-thumbnail"
                              alt={values.productImages[index]}
                              width="200"
                              src={preview}
                              data-holder-rendered="true"
                            />
                          </Col>
                        ))}
                      </Row>
                    )}
                  </Col>
                  <Col lg="12">
                    <FormGroup className="mb-0 text-right">
                      <div>
                        <Button type="submit" color="primary" className="mr-1">
                          {SUBMIT}
                        </Button>

                        <Button
                          type="reset"
                          color="secondary"
                          onClick={() => this.resetForm(false)}
                        >
                          Reset
                        </Button>
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </CustomisedModal>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = createStructuredSelector({
  productDetailApiResponse: makeProductDetailSelectField(
    "productDetailApiResponse"
  ),
});

const withConnect = connect(mapStatetoProps, {
  updateProductImagesByProductDetailIdRequest,
  getProductImagesByProductDetailIdRequest,
});

export default compose(withConnect, withRouter)(ImageUpdateForm);
//export default withRouter(withConnect)(Index);

function productImageDataInitialState() {
  return {
    productImages: [],
  };
}
